// The full X12 Transaction Set Purpose Code list (DE 353) — shared by BEG01,
// BCT01, BSN01 and every other transaction set's own purpose-code element.
// Transcribed from reference/session/00-envelope-and-common-qualifiers-txt.md.

import type {CodeListEntry} from './types';

export const TRANSACTION_SET_PURPOSE_CODES: CodeListEntry[] = [
  {code: '00', label: 'Original'},
  {code: '01', label: 'Cancellation'},
  {code: '02', label: 'Add'},
  {code: '03', label: 'Delete'},
  {code: '04', label: 'Change'},
  {code: '05', label: 'Replace'},
  {code: '06', label: 'Confirmation'},
  {code: '07', label: 'Duplicate'},
  {code: '08', label: 'Status'},
  {code: '11', label: 'Response'},
  {code: '12', label: 'Not Processed'},
  {code: '13', label: 'Request'},
  {code: '14', label: 'Advance Notification'},
  {code: '15', label: 'Re-Submission'},
  {code: '16', label: 'Proposed'},
  {code: '18', label: 'Reissue'},
  {code: '22', label: 'Information Copy'},
  {code: '25', label: 'Incremental'},
  {code: '45', label: 'Follow-up'},
  {code: 'ZZ', label: 'Mutually Defined'},
];
